<template>
  <div v-if="order" class="pb-16">
    <v-overlay
      v-model="loadingOverlay"
      color="rgba(255, 255, 255, 0.85)"
      opacity="0.85"
      z-index="7"
      light
    >
      <div class="flower-spinner ma-auto">
        <div class="dots-container">
          <div class="bigger-dot">
            <div class="smaller-dot"></div>
          </div>
        </div>
      </div>

      <div class="black--text text-center mt-5">
        <span
class="text-h6 font-weight-bold"
          >{{
            processingCC
              ? $t("order_step_3_creditcard_auth_text")
              : $t("order_step_3_order_dealing")
          }}<br /><span v-html="$t('order_step_3_plz_waiting')"></span></span
        ><br />
        Your order’s being processed.<br />
        Please wait patiently and don’t refresh this page.

        <!-- <div
          v-if="processingCC && cc3DUrl !== ''"
          class="grey lighten-1 px-8 py-2 mt-10"
        >
          {{ $t("order_step_3_click_to_outer_link") }}
          <a :href="cc3DUrl" target="_blank" class="primary-1--text">{{
            $t("order_step_3_outer_link")
          }}</a>
        </div> -->
      </div>
    </v-overlay>
    <CustomPageHeaderVue class="flex-grow-0">{{
      $t("orderlist_title")
    }}</CustomPageHeaderVue>
    <CustomRow
      v-if="!isLoading"
      :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'mb-6' : ''"
    >
      <v-card class="mt-5 py-3 px-4 cusPadding" v-if="!isRepay && welfareFee">
        <div
          class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
        >
          {{ $t("ticket_table_welfare") }}
        </div>
        <v-col
          cols="12"
          lg="8"
          md="8"
          :class="`mx-auto ${
            isSubmit && currentID === 'welfareFee' && welfareFee.type === ''
              ? 'is-need-value'
              : ''
          }`"
          id="welfareFee"
        >
          <v-radio-group v-model="welfareFee">
            <v-radio :value="true" color="primary" class="radioStyle pa-4">
              <template slot="label">
                <div>
                  {{ $t("ticket_table_welfare") }}
                  <br /><span class="text-eight">{{
                    $t("ticket_table_welfare_fee_info")
                  }}</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-card>
      <v-card class="mt-5 py-3 px-4 cusPadding">
        <div
          class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
        >
          {{ $t("orderlist_payment") }}
        </div>

        <v-col
          cols="12"
          lg="8"
          md="8"
          :class="`mx-auto ${
            currentID === 'selectedPayWay' && selectedPayWay.type === ''
              ? 'is-need-value'
              : ''
          }`"
          id="selectedPayWay"
        >
          <v-radio-group v-model="selectedPayValue">
            <template v-for="(payWay, i) in payOption">
              <v-radio
                :key="'radio-' + payWay.type"
                :value="payWay.type"
                color="primary"
                class="radioStyle pa-4"
                :class="{ 'mt-4': i !== 0 }"
                @change="selectPayWay(payWay.type)"
              >
                <template slot="label">
                  <div v-if="payWay.type === 'CC'">
                    {{ $t("orderlist_card_payment_one_time") }}
                    <br />
                    <span class="text-eight">
                      {{ $t("order_step_3_cash_flow_provider") }}
                    </span>
                  </div>
                  <div v-if="payWay.type === 'ATM'">
                    <div class="d-flex align-center">
                      {{ $t("orderlist_virtual_account") }}
                      <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="primary"
                            class="ml-1"
                            v-bind="attrs"
                            v-on="on"
                            dense
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <ul class="py-2 text-nine">
                          <li>{{ $t("order_step_3_atm_transfer_note_1") }}</li>
                          <li class="py-2">
                            {{ $t("order_step_3_atm_transfer_note_2") }}
                          </li>
                          <li class="pb-2">
                            {{ $t("order_step_3_atm_transfer_note_3") }}
                          </li>
                          <li>{{ $t("order_step_3_atm_transfer_note_4") }}</li>
                        </ul>
                      </v-tooltip>
                    </div>
                    <div class="text-eight">
                      <ul>
                        <li>
                          {{
                            $t("order_step_3_atm_transfer_expired_lottery", {
                              lotteryDeadline:
                                new Date(
                                  campaign.lotteryDeadline
                                ).toLocaleString() || "",
                            })
                          }}
                        </li>
                        <li>{{ $t("foreigner_not_suppose_payment") }}</li>
                      </ul>
                    </div>
                  </div>
                </template>
              </v-radio>
              <div
                class="grey-1 pa-5"
                :key="'content-' + payWay.type"
                v-if="payWay.type == 'CC' && selectedPayWay.type == 'CC'"
              >
                <v-alert
                  v-model="showInAppBrowserWarning"
                  class="p-4 text-left red--text pink-1 body-2 font-weight-regular rounded-lg"
                  prominent
                  role="alert"
                  type="warning"
                >
                  <span v-html="$t('in_app_browser_warning')"></span>
                </v-alert>
                <template v-if="loadingCCList">
                  <div class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary-1"
                      size="25"
                      width="2"
                    ></v-progress-circular>
                  </div>
                </template>
                <template v-else>
                  <template v-if="loadCCFailed">
                    <v-btn
                      dark
                      rounded
                      depressed
                      color="light-blue"
                      @click="selectPayWay('CC')"
                    >
                      <v-icon>mdi-replay</v-icon>
                      {{ $t("session_table_retry") }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <div
                      id="add-credit-card"
                      :class="{
                        'px-4': $vuetify.breakpoint.xs,
                        'px-8': !$vuetify.breakpoint.xs,
                        'pink-1 py-2': currentID === 'add-credit-card',
                      }"
                      class="d-flex align-center text-nine"
                    >
                      <div
                        v-if="!ccList.length"
                        @click="updateCCInfo()"
                        class="cursor-pointer"
                      >
                        <v-icon class="mr-1" dense>mdi-plus</v-icon>
                        {{ $t("creditcard_add_new_card") }}
                      </div>
                      <template v-else>
                        <div>
                          <div class="font-weight-bold">
                            {{
                              ccList.find((c) => c.isDefault == "Y")
                                .issueBankName
                            }}
                          </div>
                          <div style="color: #8d8d8d">
                            {{ ccList.find((c) => c.isDefault == "Y").mchd }}
                          </div>
                          <div class="mt-2">
                            <span
class="text-small"
                              >{{ $t("creditcard_expiry_label")
                              }}{{
                                dateFormat(
                                  ccList.find((c) => c.isDefault == "Y")
                                    .expireYm,
                                  "MM/YY"
                                )
                              }}</span
                            >
                            <span
                              :class="`expire-tag ${
                                ccList.find((c) => c.isDefault == 'Y').expired
                                  ? 'expired'
                                  : 'active'
                              }`"
                              >{{
                                ccList.find((c) => c.isDefault == "Y").expired
                                  ? $t("creditcard_expired_status")
                                  : $t("creditcard_active_status")
                              }}</span
                            >
                          </div>
                        </div>
                        <v-spacer />
                        <div
                          class="primary-1--text cursor-pointer font-weight-bold"
                          @click="updateCCInfo()"
                        >
                          {{ $t("order_step_3_change_creditcard") }}
                        </div>
                      </template>
                    </div>
                    <div class="red--text mt-3">
                      {{ $t("creditcard_add_new_card_tip") }}
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </v-radio-group>
        </v-col>
      </v-card>
      <v-card
        class="mt-5 py-3 px-4 cusPadding"
        v-if="!isRepay && needEnvoice"
        id="envoiceWay"
      >
        <div
          class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
        >
          {{ $t("order_step_3_invoice") }}
        </div>
        <v-col
          cols="12"
          lg="8"
          md="8"
          :class="`mx-auto ${
            isSubmit &&
            currentID === 'selectedEnvoiceWay' &&
            selectedEnvoice === ''
              ? 'is-need-value'
              : ''
          }`"
          id="selectedEnvoiceWay"
        >
          <v-radio-group v-model="selectedEnvoice">
            <template v-for="(envoiceWay, i) in envoiceWays">
              <v-radio
                :key="'radio-' + envoiceWay.type"
                :value="envoiceWay.type"
                color="primary"
                class="radioStyle pa-4"
                :class="{ 'mt-4': i !== 0 }"
              >
                <template slot="label">
                  <div>
                    {{ envoiceWay.name }}
                    <br /><span class="text-eight">{{
                      envoiceWay.descript
                    }}</span>
                  </div>
                </template>
              </v-radio>
              <div
                class="grey-1 pa-5"
                :key="'donate-' + envoiceWay.type"
                v-if="
                  envoiceWay.type == 'donate' && selectedEnvoice == 'donate'
                "
              >
                <div :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                  <div class="text-nine font-weight-bold">
                    {{ $t("order_step_3_select_donation_organizer") }}*
                  </div>
                  <v-select
                    v-model="donation"
                    color="primary-1"
                    background-color="white"
                    :items="donateOrganization"
                    :item-text="
                      (donateOrganization) =>
                        `${donateOrganization.code} ${donateOrganization.name}`
                    "
                    :label="$t('order_step_3_donation_organizer')"
                    outlined
                    class="mt-5"
                    :error="
                      hasInvoiceInvalid &&
                      !!invalidInvoiceError.name &&
                      donation === ''
                    "
                    :error-messages="
                      hasInvoiceInvalid && !!invalidInvoiceError.donation
                        ? [invalidInvoiceError.donation]
                        : null
                    "
                    @change="invoiceFormRequired"
                    @blur="invoiceFormRequired"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div
                class="grey-1 pa-5"
                :key="'duplicate-' + envoiceWay.type"
                v-if="
                  envoiceWay.type == 'duplicate' &&
                  selectedEnvoice == 'duplicate'
                "
                id="envoice-custom"
              >
                <v-form :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                  <div class="text-nine font-weight-bold">
                    {{ $t("order_step_3_invoice_reward_info") }}*
                  </div>
                  <v-radio-group v-model="selectedEnvoiceAddress">
                    <template
                      v-if="
                        maskedUserInfo.country === 'Taiwan' &&
                        maskedUserInfo.userName &&
                        maskedUserInfo.address
                      "
                    >
                      <v-radio
                        id="envoiceUserInfo"
                        value="1"
                        color="primary"
                        :class="$vuetify.breakpoint.xs ? '' : 'pa-4'"
                      >
                        <template slot="label">
                          <div
                            :class="
                              currentID === 'envoiceUserInfo' ||
                              !selectedEnvoiceAddress
                                ? 'red--text'
                                : ''
                            "
                          >
                            <template v-if="maskedUserInfo.userName">
                              {{ maskedUserInfo.userName }}&nbsp;&nbsp;
                            </template>
                            <template v-if="maskedUserInfo.mobile">
                              {{ maskedUserInfo.mobile }}<br />
                            </template>
                            <template v-if="maskedUserInfo.address">
                              {{ maskedUserInfo.address.split(",")[0] }}
                              {{ maskedUserInfo.address.split(",")[1] }}
                              {{ maskedUserInfo.address.split(",")[2] }}
                              {{ maskedUserInfo.address.split(",")[3] }}
                            </template>
                          </div>
                        </template>
                      </v-radio>
                      <v-divider />
                    </template>
                    <v-radio
                      id="envoiceCustomeInfo"
                      v-if="selectedEnvoiceAddress === '2'"
                      value="2"
                      color="primary"
                      :class="{
                        'pa-4': $vuetify.breakpoint.xs,
                        'with-error': hasInvoiceInvalid,
                      }"
                    >
                      <template slot="label">
                        <div>
                          <v-row class="mt-5">
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="receiptInfo.name"
                                :label="$t('userinfo_name')"
                                color="primary-1"
                                outlined
                                required
                                :autofocus="true"
                                background-color="white"
                                :class="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.name &&
                                  receiptInfo.name === ''
                                    ? 'error-text'
                                    : ''
                                "
                                :error="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.name &&
                                  receiptInfo.name === ''
                                "
                                :error-messages="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.name
                                    ? [invalidInvoiceError.name]
                                    : null
                                "
                                @change="invoiceFormRequired"
                                @blur="invoiceFormRequired"
                              >
                                <template #message="{ message }">
                                  {{ $t(message) }}
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="receiptInfo.mobile"
                                :label="$t('userinfo_phone_number')"
                                color="primary-1"
                                outlined
                                required
                                background-color="white"
                                :class="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.name &&
                                  receiptInfo.mobile === ''
                                    ? 'error-text'
                                    : ''
                                "
                                :error="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.name &&
                                  receiptInfo.mobile === ''
                                "
                                :error-messages="
                                  hasInvoiceInvalid &&
                                  !!invalidInvoiceError.mobile
                                    ? [invalidInvoiceError.mobile]
                                    : null
                                "
                                @change="invoiceFormRequired"
                                @blur="invoiceFormRequired"
                              >
                                <template #message="{ message }">
                                  {{ $t(message) }}
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="">
                              <RegionSelect
                                :hasInvalid="hasInvoiceInvalid"
                                :invalidError="invalidInvoiceError"
                                :onlyLocale="true"
                                :propsCountry="'Taiwan'"
                                :propsCounty="receiptInfo.county"
                                :propsDistrict="receiptInfo.district"
                                :propsAddress="receiptInfo.address"
                                :propsPostalCode="receiptInfo.postalCode"
                                @updateAddress="emitUpdateReceiptAddress"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <div
                    @click="setNewInvoiceInfo"
                    v-if="
                      !selectedEnvoiceAddress || selectedEnvoiceAddress === '1'
                    "
                    :class="{
                      'mx-4': !$vuetify.breakpoint.xs,
                      'pink-1 py-2': [
                        'envoiceCustomeInfo',
                        'selectedEnvoiceWay',
                      ].includes(currentID),
                    }"
                    class="cursor-pointer text-nine"
                  >
                    <v-icon class="mr-1" dense>mdi-plus</v-icon
                    >{{ $t("order_step_3_add_receiver_address") }}
                  </div>
                </v-form>
              </div>
              <div
                class="grey-1 pa-5"
                :key="'triplicate-' + envoiceWay.type"
                v-if="
                  envoiceWay.type == 'triplicate' &&
                  selectedEnvoice == 'triplicate'
                "
              >
                <v-form
                  :class="$vuetify.breakpoint.xs ? '' : 'px-5'"
                  v-model="invalidInvoiceError"
                >
                  <div :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                    <div class="text-nine font-weight-bold">
                      {{ $t("order_step_3_business_operator_info") }}*
                    </div>
                    <v-text-field
                      id="company"
                      v-model="company"
                      background-color="white"
                      color="primary-1"
                      :items="donateOrganization"
                      :label="$t('order_step_3_corp_name')"
                      outlined
                      class="mt-5"
                      :error="
                        hasInvoiceInvalid &&
                        !!invalidInvoiceError.company &&
                        company === ''
                      "
                      :error-messages="
                        hasInvoiceInvalid && !!invalidInvoiceError.company
                          ? [invalidInvoiceError.company]
                          : null
                      "
                      @change="invoiceFormRequired"
                      @blur="invoiceFormRequired"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-text-field>
                    <v-col cols="12" sm="6" class="pa-0">
                      <v-text-field
                        id="companyCode"
                        v-model="companyCode"
                        background-color="white"
                        color="primary-1"
                        :items="donateOrganization"
                        :label="$t('order_step_3_corp_number')"
                        outlined
                        :error="
                          hasInvoiceInvalid &&
                          !!invalidInvoiceError.companyCode &&
                          companyCode === ''
                        "
                        :error-messages="
                          hasInvoiceInvalid && !!invalidInvoiceError.companyCode
                            ? [invalidInvoiceError.companyCode]
                            : null
                        "
                        @change="invoiceFormRequired"
                        @blur="invoiceFormRequired"
                      >
                        <template #message="{ message }">
                          {{ $t(message) }}
                        </template>
                      </v-text-field>
                    </v-col>
                  </div>
                </v-form>
              </div>
            </template>
          </v-radio-group>
          <ul class="mt-5">
            <li class="text-eight text-left customMark">
              {{ $t("order_step_3_invoice_note") }}
            </li>
          </ul>
        </v-col>
      </v-card>
      <v-card class="mt-5 py-3 px-4">
        <TicketTable
          :thead="thead"
          :tickets="order.tickets"
          :discount="order.discount || 0"
          :order="order"
          :isShippingFee="order && order.shippingType == 'post'"
        >
          <template slot="title">{{ $t("orderlist_overview") }}</template>
        </TicketTable>
        <template v-if="!isLoading && campaign && campaign.recaptchaEnable">
          <div
            :class="`mt-3 d-flex justify-end ${
              isSubmit && !token ? 'is-need-value' : ''
            }`"
            id="recaptcha"
          >
            <recaptcha
              ref="recaptcha"
              :siteKey="siteKey"
              @verify="verifyMethod"
            />
          </div>
        </template>
      </v-card>
    </CustomRow>

    <div class="order-footer">
      <CustomRow>
        <v-row no-gutters class="py-3 align-center">
          <v-col cols="6" class="d-flex flex-column flex-md-row">
            <template>
              <span class="text-nine">{{
                $t("order_step_3_total_price")
              }}</span>
              <span v-if="$vuetify.breakpoint.xs" class="primary-1--text ml-1">
                <h2>
                  NT.
                  {{
                    order.totalAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                </h2>
              </span>
              <div v-else class="ml-3 align-self-start primary-1--text">
                <h2>
                  NT.
                  {{
                    order.totalAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                </h2>
              </div>
            </template>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn
              class="nextBtn"
              depressed
              large
              @click="beforePay"
              :width="
                $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 100 : 210
              "
            >
              {{ $t("lottery_payment") }}
            </v-btn>
          </v-col>
        </v-row>
      </CustomRow>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Cookies from 'js-cookie'
import CC from '@/api/config-center'
import OM from '@/api/order-management'
import { getEvent, getSessions } from '@/api/static'
import TicketTable from '@/views/order/components/TicketsTable'
import donateOrganizationJS from '@/static/donateOrganization.js'
import RegionSelect from '@/views/auth/components/RegionSelect.vue'
import Recaptcha from '@/components/Recaptcha'
import CustomPageHeaderVue from '@/components/CustomPageHeader.vue'
import { encrypt } from '@/vendor/crypto'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' // dependent on utc plugin
import jwt_decode from 'jwt-decode'
import { decrypt as AESdecrypt } from '../../../vendor/AEScrypto'
import { isIOSInAppBrowser } from '@/shared/webViewRedirect'
import { PaymentProcessMixin } from '@/shared/mixins/paymentProcessMixin'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Taipei')

export default {
  name: 'OrderedPayment',
  mixins: [PaymentProcessMixin],
  components: {
    TicketTable,
    CustomPageHeaderVue,
    RegionSelect,
    Recaptcha
  },
  data() {
    return {
      abortController: new AbortController(),
      contentHeight: window.innerHeight - 420,
      isLoading: true,
      isAbort: false,
      isRepay: false,
      welfareFee: false,
      loadingOverlay: false,
      loadCCFailed: false,
      processingCC: false,
      isOrderSuccessed: false,
      isSubmit: false,
      areaAssignmen: false,
      seatAssignmen: false,
      campaign: null,
      session: null,
      currentID: '',
      selectedPayValue: '',
      token: '',
      order: null,
      loadingCCList: false,
      ccList: [],
      showInAppBrowserWarning: false,
      payWays: [
        {
          type: 'CC'
        },
        {
          type: 'ATM'
        }
      ],
      envoiceWays: [
        {
          type: 'donate',
          name: this.$t('order_step_3_donate_name')
        },
        {
          type: 'duplicate',
          name: this.$t('order_step_3_donate_personal_title'),
          descript: this.$t('order_step_3_donate_personal_content')
        },
        {
          type: 'triplicate',
          name: this.$t('order_step_3_donate_corp_title'),
          descript: this.$t('order_step_3_donate_corp_content')
        }
      ],
      selectedPayWay: { type: '' },
      selectedEnvoiceWay: { type: '' },
      selectedEnvoice: '',
      invalidInvoiceError: {},
      hasInvoiceInvalid: true,
      donation: '',
      maskedUserInfo: {},
      receiptInfo: {
        name: '',
        mobile: '',
        postalCode: '',
        county: '',
        district: '',
        address: ''
      },
      company: '',
      companyCode: '',
      selectedEnvoiceAddress: '1'
    }
  },
  watch: {
    selectedEnvoice(newVal, old) {
      if (newVal !== old) {
        this.selectedEnvoiceWay = this.envoiceWays.find(
          (envoice) => envoice.type === newVal
        )
      }
    },
    selectedPayValue(newVal) {
      this.selectedPayWay.type = newVal
    }
  },
  computed: {
    donateOrganization() {
      return donateOrganizationJS
    },
    userInfoValid() {
      return (
        this.maskedUserInfo.userName &&
        this.maskedUserInfo.userName !== '' &&
        this.maskedUserInfo.address &&
        this.maskedUserInfo.address !== ''
      )
    },
    canNextStep() {
      return (
        !!this.isPaySelect &&
        (!this.needEnvoice || (this.needEnvoice && this.isEnvoiceSelect))
      )
    },
    payOption() {
      const payways = !['', 'UNASSIGNED'].includes(this.order.transType)
        ? this.payWays.filter((p) => p.type === this.order.transType)
        : this.payWays
      return this.campaign
        ? payways.filter((payWay) =>
          this.campaign.payment.includes(payWay.type)
        )
        : []
    },
    needEnvoice() {
      return (
        this.envoiceWays.length &&
        !this.isRepay &&
        (this.welfareFee ||
          !!this.campaign.receipt ||
          (this.selectedGetWay && this.selectedGetWay.type === 'post'))
      )
    },
    isEnvoiceSelect() {
      if (!this.needEnvoice) {
        return true
      } else {
        if (this.selectedEnvoice === 'donate') return this.donation
        if (this.selectedEnvoice === 'duplicate') {
          return (
            this.selectedEnvoiceAddress === '1' ||
            (this.selectedEnvoiceAddress === '2' &&
              !Object.values(this.receiptInfo).filter((value) => !value).length)
          )
        }
        if (this.selectedEnvoice === 'triplicate') {
          return this.company && this.companyCode
        }

        return false
      }
    },
    isPaySelect() {
      if (!this.payWays.length) return true
      else {
        if (this.selectedPayWay.type === 'CC') { return this.ccList.length && this.selectedPayWay.type }
        return this.selectedPayWay.type
      }
    },
    receiptInfoValid() {
      let result = true
      for (const i in this.receiptInfo) {
        if (!this.receiptInfo[i] || this.receiptInfo[i] === '') result = false
      }
      return result
    },
    thead() {
      const defaultHead = [
        {
          name: 'productName',
          label: this.$t(`orderlist_product_name`),
          col: this.areaAssignment && !this.seatAssignment ? 3 : 5,
          class: this.$vuetify.breakpoint.xs ? 'pl-4' : 'px-8'
        },
        {
          name: 'count',
          label: this.$t(`orderlist_product_count`),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? 'text-right pr-4'
            : 'text-center'
        },
        {
          name: 'price',
          label: this.$t('order_step_2_product_price'),
          col: this.areaAssignment && !this.seatAssignment ? 2 : 3,
          class: this.$vuetify.breakpoint.xs ? 'pl-4 mt-2' : 'text-center'
        },
        {
          name: 'sum',
          label: this.$t('orderlist_product_sum'),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? 'text-right pr-4 mt-2'
            : 'text-center'
        }
      ]
      return this.order.tickets[0].ticketAreaName &&
        this.order.tickets[0].seatInfo
        ? [
          {
            name: 'ticketAreaName',
            label: this.$t(`orderlist_ticketarea_name`),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs ? 'pl-4' : 'px-8'
          },
          {
            name: 'seat',
            label: this.$t('orderlist_ticketarea_seat'),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs
              ? 'text-right pr-4'
              : 'text-center'
          },
          {
            name: 'productName',
            label: this.$t('orderlist_product_name'),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs ? 'pl-4 mt-4' : 'text-center'
          },
          {
            name: 'price',
            label: this.$t('orderlist_product_sum'),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs
              ? 'text-right pr-4 mt-4'
              : 'text-center'
          }
        ]
        : this.order.tickets[0].ticketAreaName &&
          !this.order.tickets[0].seatInfo
          ? [
            {
              name: 'ticketAreaName',
              label: this.$t('orderlist_ticketarea_name'),
              col: 12,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? 'pl-4' : 'px-8'
            },
            ...defaultHead
          ]
          : defaultHead
    }
  },
  methods: {
    dateFormat(date, format) {
      if (!date) return ''
      const year = date.substring(0, 4)
      const month = date.substring(4, 6)
      if (format === 'MM/YY') {
        return `${month}/${year.substring(2, 4)}`
      }
    },
    ...mapActions({
      showDialog: 'dialog/show',
      setRecaptchaStatus: 'user/setRecaptchaStatus'
    }),
    getMaskedUserInfo() {
      const user = JSON.parse(Cookies.get('user'))
      const token = jwt_decode(user.access_token)

      this.maskedUserInfo = {
        userName: token.maskedUserName,
        mobile: token.maskedMobile,
        email: token.maskedEmail,
        birthday: token.maskedBirthday,
        address:
          token.encryptedAddress && token.encryptedAddress.encryptedData
            ? AESdecrypt(
              token.encryptedAddress.encryptedData,
              token.encryptedAddress.iv
            )
            : '',
        country:
          !!token.country && token.country !== '' ? token.country : 'Taiwan'
      }

      this.$forceUpdate()

      if (
        !(
          this.maskedUserInfo.country === 'Taiwan' &&
          this.maskedUserInfo.userName &&
          this.maskedUserInfo.address
        )
      ) { this.selectedEnvoiceAddress = '2' }
    },
    getCampaignOptions() {
      const campaignOptions = {
        payment: this.campaign.payment || [],
        pickup: this.campaign.pickUp || [],
        receipt: this.campaign.receipt || []
      }

      this.payWays = this.payWays.filter((payWay) =>
        campaignOptions.payment.includes(payWay.type)
      )
      this.envoiceWays =
        campaignOptions.receipt || this.welfareFee ? this.envoiceWays : []
    },
    emitUpdateReceiptAddress(address) {
      this.receiptInfo.county = address.county
      this.receiptInfo.district = address.district
      this.receiptInfo.address = address.address
      this.receiptInfo.postalCode = address.postalCode
      this.invoiceFormRequired()
    },
    async timeout(timer = 5000) {
      return new Promise((resolve) => {
        setTimeout(resolve, timer)
      })
    },
    setNewInvoiceInfo() {
      this.selectedEnvoiceAddress = '2'
      this.receiptInfo = {
        name: '',
        mobile: '',
        postalCode: '',
        county: '',
        district: '',
        address: ''
      }
    },
    invoiceFormRequired() {
      this.invalidInvoiceError = {}

      if (this.selectedEnvoiceWay.type === 'donate' && this.donation === '') {
        this.invalidInvoiceError['donation'] = 'field_required'
      } else if (
        this.selectedEnvoiceWay.type === 'duplicate' &&
        this.selectedEnvoiceAddress === '2'
      ) {
        for (var i in this.receiptInfo) {
          const item = this.receiptInfo[i]
          if (!item || item === '' || !/^(?!\s*$).+/.test(item)) {
            this.invalidInvoiceError[i] = 'field_required'
          } else if (i === 'email' && !/.+@.+\..+/.test(item)) {
            this.invalidInvoiceError[i] = 'email_format_error'
          }
        }
      } else if (this.selectedEnvoiceWay.type === 'triplicate') {
        const keys = ['company', 'companyCode']
        for (const key of keys) {
          if (this[key] === '' || !/^(?!\s*$).+/.test(this[key])) {
            this.invalidInvoiceError[key] = 'field_required'
          }
        }
      }
      this.hasInvoiceInvalid = Object.keys(this.invalidInvoiceError).length > 0
      return Object.keys(this.invalidInvoiceError).length === 0
    },
    receiptInfoContent(type) {
      if (type === 'donate') {
        return { organization: this.donation.split(' ')[0] }
      }
      if (type === 'duplicate') return this.receiptInfo
      if (type === 'triplicate') {
        return {
          organization: this.company,
          taxIdNumber: this.companyCode
        }
      }

      return null
    },
    orderSuccessed() {
      this.isSubmit = false
      this.isOrderSuccessed = true
      this.$router
        .push({
          name: 'OrderedComplete',
          params: { orderId: this.order.orderId }
        })
        .catch(() => {})
    },
    orderFailed() {
      this.isSubmit = false
      this.loadingOverlay = false
      if (this.selectedPayWay.type === 'CC' || this.selectedPayValue === 'CC') {
        this.showDialog({
          error: true,
          title: this.$t('order_creditcard_fail_title'),
          content: this.$t('order_creditcard_fail_content'),
          button: this.$t('order_step_1_reserve_dialog_cta'),
          action: () => {
            this.$router
              .push({
                name: 'OrderList'
              })
              .catch(() => {})
          }
        })
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t('order_step_3_order_fail')}</div>
            </div>`
        })
        let timer = null
        timer = setTimeout(() => {
          clearTimeout(timer)
          this.$router
            .push({
              name: 'OrderList'
            })
            .catch(() => {})
        }, 3000)
      }
    },
    async apiGetOrderInfo() {
      if (this.isAbort) return
      const { data: getOrderInfoRes } = await OM.getPurchaseInfo(
        this.order.orderId,
        this.abortController
      )
      if (getOrderInfoRes.errCode === '00') {
        // ATM && atmAccount
        if (getOrderInfoRes.atmAccount) {
          this.orderSuccessed()
        } else if (getOrderInfoRes.txStatus === 'SUCCESS') {
          this.loadingOverlay = false
          this.orderSuccessed()
        } else if (getOrderInfoRes.txStatus === 'FAILED') {
          console.error('getOrderInfo failed')
          this.orderFailed()
        } else if (
          getOrderInfoRes.transType === '' ||
          getOrderInfoRes.txStatus === '' ||
          (this.selectedPayValue === 'ATM' && !getOrderInfoRes.atmAccount)
        ) {
          return setTimeout(() => this.apiGetOrderInfo(), 5000)
        } else return getOrderInfoRes
        return false
      } else {
        this.orderFailed()
        return false
      }
    },
    async retryGetOrderInfo() {
      await this.timeout()
      if (this.isAbort) return
      return await this.apiGetOrderInfo()
    },
    async get3dCCLink() {
      setTimeout(async() => {
        let result = await this.apiGetOrderInfo()
        if (result) {
          while (
            (result && result.txStatus === 'WAITING') ||
            result.txStatus === '3D'
          ) {
            result = await this.retryGetOrderInfo()
            if (
              !!result &&
              result.txStatus &&
              result.txStatus === '3D' &&
              !this.open3DTabLink &&
              !!result.cc3DUrl &&
              result.cc3DUrl !== ''
            ) {
              this.cc3DUrl = result.cc3DUrl
              this.getcc3DUrl = true
              this.showDialog({
                error: true,
                title: this.$t('order_step_3_cc_verify_title'),
                content: this.$t('order_step_3_cc_verify_content'),
                button: this.$t('layout_notification_confirm'),
                outerLink: result.cc3DUrl,
                action: () => {
                  this.open3DTabLink = true
                }
              })
            }
            if (!this.getcc3DUrl) {
              this.get3dCCLink()
            }
          }
        }
      }, 3000) // 改成 3sec
    },
    beforePay() {
      if (this.payOption.length === 1 || this.order.isShowCCToCCRepayBtn) {
        this.pay()
      } else {
        this.showDialog({
          title: this.$t('ordered_payment_confirm_title'),
          content: this.$t('ordered_payment_confirm_content'),
          buttons: [
            {
              text: this.$t('layout_notification_cancel'),
              style: {
                block: true,
                outlined: true,
                color: 'primary'
              },
              action() {}
            },
            {
              text: this.$t('layout_notification_confirm'),
              style: {
                depressed: true,
                block: true,
                outlined: false,
                color: 'primary'
              },
              action: async() => {
                this.pay()
              }
            }
          ]
        })
      }
    },
    async pay() {
      let elem = null
      if (!this.canNextStep) {
        if (
          this.payWays.length &&
          this.campaign.payment &&
          !this.campaign.payment.includes('FREE') &&
          this.selectedPayWay.type === ''
        ) {
          this.currentID = 'selectedPayWay'
          elem = document.querySelector('#selectedPayWay')
        } else if (this.selectedPayWay.type === 'CC' && !this.ccList.length) {
          this.currentID = 'add-credit-card'
          elem = document.querySelector('#add-credit-card')
        } else if (this.needEnvoice) {
          this.currentID = 'selectedEnvoiceWay'
          elem = document.querySelector('#selectedEnvoiceWay')
        } else if (
          this.selectedEnvoiceWay.type !== '' &&
          (!this.selectedEnvoiceAddress ||
            this.selectedEnvoiceAddress === '' ||
            this.selectedEnvoiceAddress === '1') &&
          !this.invoiceFormRequired()
        ) {
          this.currentID = 'envoiceCustomeInfo'
          elem = document.querySelector('#envoice-custom')
        } else if (
          this.selectedEnvoiceWay.type !== '' &&
          this.hasInvoiceInvalid &&
          !this.invoiceFormRequired()
        ) {
          this.invoiceFormRequired()
          this.hasInvoiceInvalid = true
          this.currentID = 'envoiceCustomeInfo'
          elem = document.querySelector('#envoiceCustomeInfo')
        }

        const rect = elem ? elem.getBoundingClientRect() : null
        // console.log(elem, window.scrollTop, elem.parentNode.offsetTop, rect)
        window.scrollTo({
          left: 0,
          top: elem && rect
            ? window.scrollY + rect.top - 200
            : document.body.clientHeight,
          behavior: 'smooth'
        })

        this.isSubmit = false
        return
      }
      this.isSubmit = true
      this.loadingOverlay = true
      let receiptInfo = {}
      if (this.needEnvoice && this.selectedEnvoiceWay.type !== '') {
        receiptInfo = {
          type: this.selectedEnvoiceWay.type,
          content:
            this.selectedEnvoiceWay.type === 'duplicate' &&
            this.selectedEnvoiceAddress === '1'
              ? null
              : this.receiptInfoContent(this.selectedEnvoiceWay.type)
        }
      }
      const { data } = await OM.paymentProcess({
        orderNum: this.order.orderNum,
        transType: this.selectedPayValue,
        isRepay: Boolean(this.$route.query?.repay),
        receiptInfo
      })
      if (data.errCode === '00') {
        if (this.selectedPayValue === 'CC') {
          this.processingCC = true
          this.get3dCCLink()
        } else {
          this.orderSuccessed()
        }
      } else {
        if (data.errCode === '138') {
          this.isSubmit = false
          this.loadingOverlay = false
          this.showDialog({
            error: true,
            title: this.$t('order_creditcard_fail_title'),
            content: this.$t('order_creditcard_fail_content'),
            button: this.$t('order_step_1_reserve_dialog_cta'),
            action: () => {
              this.$router
                .push({
                  name: 'OrderList'
                })
                .catch(() => {})
            }
          })
        } else this.orderFailed()
      }
    },

    verifyMethod(response) {
      this.token = response
    },
    async getSessionInfo(sessionData, sessionInfo) {
      this.session = {
        ...sessionData,
        ...sessionInfo[0]
      }
      this.$store.dispatch('setOverlayLoading', false)
    },
    async init() {
      const { data } = await OM.getAllPurchases(this.$route.params.orderNum)
      if (data.errCode === '00') {
        this.order = {
          ...data.data[0],
          tickets: data.data[0].tickets.map((t) => ({
            ...t,
            seat: t.seatInfo.seat
          }))
        }
        if (
          (!this.order.isShowPaymentBtn && !this.order.isShowCCToCCRepayBtn) ||
          this.order.payStatus === '已付款'
        ) {
          this.$router.push({
            name: 'OrderList'
          })
        } else {
          this.isRepay = Boolean(this.$route.query?.repay)
          this.initInfo()
        }
      }
    },
    async initInfo() {
      const { data: eventsData } = await getEvent(encrypt(this.order.eventId))
      const { data: sessionData } = await getSessions(
        encrypt(this.order.eventId)
      )

      this.welfareFee = this.order.isWelfareFeeOrder && this.order.welfareFee
      const [{ data: infoData }] = await CC.getInfos({
        eventId: [encrypt(this.order.eventId)],
        sessionId: [encrypt(this.order.sessionId)]
      })
      if (infoData.errCode === '00') {
        this.campaign = { ...eventsData, ...infoData.result.event[0] }
        await this.getSessionInfo(
          sessionData.sessions.find(({ sessionId }) => {
            const sid = /^s[0-9]{9}$/.test(sessionId)
              ? encrypt(sessionId)
              : sessionId
            return sid === this.$route.params.sessionId
          }),
          infoData.result.session
        )
        this.isLoading = false
      }
      await this.getMaskedUserInfo()
      await this.getCampaignOptions()
    },
    selectPayWay(type) {
      if (type === 'CC') {
        this.getUserCCInfo()
      }
      if (type === 'ATM') this.ccList = []

      this.selectedPayWay.type = type
    },
    leave(to) {
      this.isAbort = false
      this.isSubmit = false
      this.$router
        .push({
          name: to.name
        })
        .catch(() => {})
    }
  },
  created() {
    this.$store.dispatch('setOverlayLoading', true)
  },
  mounted() {
    this.showInAppBrowserWarning = isIOSInAppBrowser()
  },
  beforeMount() {
    this.init()
  },
  beforeDestroy() {
    this.setRecaptchaStatus('')
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSubmit && !this.isAbort) {
      next(false)
      this.isAbort = true
      alert(this.$t('lottery_leave_payment'))
      this.abortController.abort()
      this.leave(to)
      return false
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
::v-deep.rwd-padding {
  padding: 0;

  @media screen and (min-width: 1024px) {
    [role="separator"] + div [class*="col"] {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
}

::v-deep.radioStyle {
  border-radius: 5px;
  border: 2px solid #c4c4c4;
  color: #c4c4c4;

  .v-label {
    flex-direction: row;
    align-items: center;
  }

  &:not(.v-item--active) .v-label .primary-1--text {
    color: $grey-1 !important;
  }

  .getWayAppend {
    margin-top: 0;
  }

  label,
  .mdi-radiobox-blank,
  .mdi-information-outline {
    color: #c4c4c4;
  }

  .v-input--selection-controls__input {
    margin-right: 12px;
  }

  &.v-item--active {
    border: 2px solid $primary-dark;

    label {
      color: #444;
    }

    .getWayName,
    .getWayAppend {
      font-weight: 500;
    }

    .getWayAppend,
    .mdi-information-outline {
      color: $primary-1;
    }
  }

  @media screen and (max-width: 600px) {
    .v-label,
    .v-label {
      flex-direction: column;
      align-items: start;
    }

    .getWayAppend {
      align-items: start;
      margin-top: 12px;
      font-weight: 500;
    }
  }
}

.order-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 5;

  .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  .row [class*="col"] {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.is-need-value .v-radio {
  border-color: transparentize($accent-red, 0.5);
}

.expire-tag {
  display: inline-flex;
  height: 22px;
  font-size: 12px;
  border-radius: 12px;
  padding: 0 8px;
  margin-left: 8px;
  justify-content: center;
  align-items: center;

  &.active {
    color: white;
    background-color: #28bd92;
  }

  &.expired {
    color: #e64343;
    border: 1px solid #e64343;
    background-color: #fff;
  }
}
</style>
